import { getAvailableDevices, putActiveDevice } from "../controllers/SpotifyApiController";
import { getActiveDevice, getPointedDevice } from "../reducers/devices";
import { manageTooManyRequestsResponse } from "../utils/connectionUtils";
import { setPlaybackAction } from "./disablingProcessesActions";

export const SET_AVAILABLE_DEVICES = 'SET_AVAILABLE_DEVICES';
export const SET_POINTED_DEVICE = 'SET_POINTED_DEVICE';
export const SET_ACTIVE_DEVICE = 'SET_ACTIVE_DEVICE';

export const setAvailableDevices = () => {
    const manageActiveDevice = (dispatch, state, devices) => {
        const newActiveDevice = devices.find((device) => device.is_active);
        const currentActiveDevice = getActiveDevice(state);

        if((newActiveDevice && (!currentActiveDevice || currentActiveDevice.id !== newActiveDevice.id)) || // There's a new activeDevice
            (!newActiveDevice && currentActiveDevice)) // Or the activeDevice has been closed or inactive
        {
            dispatch(setActiveDevice(newActiveDevice));
        }

        return newActiveDevice;
    }

    const managePointedDevice = (dispatch, state, devices, activeDevice) => {
        const pointedDevice = getPointedDevice(state);

        // The active device has priority in order to be the pointed device
        // That means that if there is no pointed device saved yet or the saved pointed device is not the active device...
        if(activeDevice && (!pointedDevice || pointedDevice.id !== activeDevice.id))
        {
            // Then, the pointed device has to be set as the active device
            dispatch(setPointedDevice(activeDevice));
            // And nothing more has to be done
            return;
        }

        // There is already a pointed device saved
        if(pointedDevice)
        {
            // The saved pointed device is looked for among the available devices
            const actualPointedDevice = devices.find((device) => device.id === pointedDevice.id);

            // If it doesn't exist, that means that the current pointed device is not an available device anymore
            if(!actualPointedDevice)
            {
                // In that case, the saved pointed device is cleared
                dispatch(setPointedDevice(undefined));
            }
        }
    }

    return (dispatch, getState) => {
        return getAvailableDevices()
            .then((result) => {
                const devices = result.devices;
                const state = getState();
                
                dispatch({ type: SET_AVAILABLE_DEVICES, payload: devices });

                if(devices && devices.length > 0) {
                    const activeDevice = manageActiveDevice(dispatch, state, devices);
                    managePointedDevice(dispatch, state, devices, activeDevice);
                }
                else {
                    dispatch(setPointedDevice(undefined));
                }
            })
            .catch((error) => {
                manageTooManyRequestsResponse(error, dispatch);
                console.error('Error fetching available devices: ', error);
            })
    }
}

export const setPointedDevice = (device) => ({ type: SET_POINTED_DEVICE, payload: device });
export const setActiveDevice = (device) => ({ type: SET_ACTIVE_DEVICE, payload: device });

export const transferDevice = (device, playing) => {
    return (dispatch) => {
        dispatch(setPlaybackAction(true));

        return putActiveDevice(device.id, playing)
            .then(() => {
                dispatch(setPlaybackAction(false));
                dispatch(setPointedDevice(device));
            })
            .catch((error) => {
                dispatch(setPlaybackAction(false));
                manageTooManyRequestsResponse(error, dispatch);
                console.error('Error transferring active device: ', error);
            })
    }
}